import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { ServerDataSource } from 'ng2-smart-table';
import { environment } from '../../../../../../environments/environment';

@Injectable()
export class GenericHttpService<T> {

  get apiUrl(): string {
    return environment.apiUrl;
  }

  constructor(private http: HttpClient) {}

  getServerDataSource(uri: string): DataSource {
    return new ServerDataSource(this.http,
      {
        endPoint: uri,
        totalKey: 'totalCount',
        dataKey: 'items',
        pagerPageKey: 'pageNumber',
        pagerLimitKey: 'pageSize',
        filterFieldKey: 'filterBy#field#',
        sortFieldKey: 'sortBy',
        sortDirKey: 'orderBy',
      });
  }

  get(endpoint: string, options?): Observable<HttpEvent<T[]>> {
    return this.http.get<T[]>(`${this.apiUrl}/${endpoint}`, options);
  }

  getSingle(endpoint: string, options?): Observable<HttpEvent<T>> {
    return this.http.get<T>(`${this.apiUrl}/${endpoint}`, options);
  }

  post(endpoint: string, data, options?): Observable<any> {
    return this.http.post<T>(`${this.apiUrl}/${endpoint}`, data, options);
  }

  put(endpoint: string, data, options?): Observable<any> {
    return this.http.put<T>(`${this.apiUrl}/${endpoint}`, data, options);
  }

  remove(endpoint: string, options?): Observable<any> {
    return this.http.delete<boolean>(`${this.apiUrl}/${endpoint}`, options);
  }

  getAny(endpoint: string, options?) {
    return this.http.get<T[]>(`${this.apiUrl}/${endpoint}`, options);
  }
}
